import React from 'react'
import ReactDOM from 'react-dom'

const Portal = ({ elementClassName = 'wrapper', children }) => {
  const renderNode =
    elementClassName && document.querySelector(`.${elementClassName}`)

  const addedClassName = 'wrapper--overflow'

  renderNode.classList.add(addedClassName)

  React.useEffect(() => {
    const el = document.createElement('div')
    if (renderNode) renderNode.appendChild(el)

    return () => {
      if (renderNode) {
        renderNode.removeChild(el)
        renderNode.classList.remove(addedClassName)
      }
    }
  }, [renderNode])

  if (!renderNode) return children

  return ReactDOM.createPortal(children, renderNode)
}

export default Portal
